<template>
  <div class="row">
    <div class="col-md-3">
      <card
        :title="configuraciones"
        class="settings-card"
      >
        <ul class="nav flex-column nav-pills">
          <li
            v-for="tab in tabs"
            :key="tab.route"
            class="nav-item"
          >
            <router-link
              :to="{ name: tab.route }"
              class="nav-link grey--text text--darken-4"
              :active-class="themeColor"
            >
              <fa
                :icon="tab.icon"
                fixed-width
              />
              {{ tab.name }}
            </router-link>
          </li>
        </ul>
      </card>
    </div>

    <div class="col-md-9">
      <transition
        name="fade"
        mode="out-in"
      >
        <router-view />
      </transition>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  middleware: 'auth',
  data: () => ({
    configuraciones: 'Configuraciones',
  }),
  computed: {
    ...mapGetters({
      themeColor: 'theme/themeColor',
    }),
    tabs() {
      return [
        {
          icon: 'user',
          name: 'Perfil',
          route: 'settings.profile',
        },
        {
          icon: 'lock',
          name: 'Contraseña',
          route: 'settings.password',
        },
        {
          icon: 'user',
          name: 'Perfil de Distribuidor',
          route: 'settings.profileEnterprise',
        },
      ];
    },
  },
};
</script>

<style>
.settings-card .card-body {
  padding: 0;
}
</style>
